<template>
  <svg
    v-if="gSiteName === 'xoilaczxc'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_15_5367)">
      <path
        d="M13.0153 4.49356C11.8863 2.1881 9.52441 0.663879 6.87514 0.663879C3.08433 0.663879 0.000301026 3.73041 0.000301026 7.49966C0.000301026 8.52401 0.220218 9.50582 0.65427 10.4212L0.0116679 13.6346C-0.070127 14.0437 0.290724 14.4052 0.699855 14.3243L3.95286 13.6812C4.39086 13.8889 4.84398 14.0469 5.30955 14.1558C4.26594 9.2129 8.01257 4.57316 13.0153 4.49356Z"
        fill="#7E8793"
      />
      <path
        d="M19.3458 15.4211C19.4581 15.1844 19.5557 14.9431 19.6392 14.6979H19.6178C21.0806 10.4044 18.0043 5.89186 13.463 5.67214C13.4629 5.6719 13.4628 5.67167 13.4628 5.67143C9.5552 5.49136 6.30872 8.62004 6.30872 12.4996C6.30872 16.2656 9.36962 19.3297 13.1345 19.3352C14.1556 19.3338 15.1344 19.114 16.0472 18.6811C19.6099 19.3854 19.332 19.3353 19.4139 19.3353C19.7841 19.3353 20.0607 18.996 19.9884 18.6345L19.3458 15.4211Z"
        fill="#7E8793"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_5367">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
  <svg
    v-else-if="gSiteName === 'xoilactivi'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="as-not-change-color"
  >
    <g clip-path="url(#clip0_491_549)">
      <path
        d="M13.0153 4.49362C11.8863 2.18816 9.52441 0.66394 6.87514 0.66394C3.08433 0.66394 0.000301026 3.73047 0.000301026 7.49972C0.000301026 8.52407 0.220218 9.50588 0.65427 10.4213L0.0116679 13.6347C-0.070127 14.0437 0.290724 14.4053 0.699855 14.3244L3.95286 13.6812C4.39086 13.889 4.84398 14.047 5.30955 14.1559C4.26594 9.21296 8.01257 4.57322 13.0153 4.49362Z"
        fill="#00FF5E"
      />
      <path
        d="M19.3457 15.4212C19.458 15.1844 19.5556 14.9432 19.6391 14.698H19.6177C21.0804 10.4044 18.0042 5.89189 13.4628 5.67217C13.4628 5.67193 13.4627 5.6717 13.4626 5.67147C9.55508 5.49139 6.30859 8.62007 6.30859 12.4996C6.30859 16.2657 9.3695 19.3298 13.1343 19.3352C14.1555 19.3339 15.1343 19.114 16.0471 18.6811C19.6098 19.3854 19.3319 19.3354 19.4138 19.3354C19.784 19.3354 20.0606 18.9961 19.9883 18.6346L19.3457 15.4212Z"
        fill="#B4BEC1"
      />
    </g>
    <defs>
      <clipPath id="clip0_491_549">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
  <svg
    v-else
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_406_2682)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.668718 14.3259C0.861538 14.4295 1.07179 14.4818 1.28205 14.4818C1.52615 14.4818 1.76821 14.4131 1.98051 14.2746L3.84308 13.0674C3.92485 13.014 4.0119 12.9706 4.10258 12.9377V14.1444C4.10258 15.7003 5.3672 16.9649 6.9231 16.9649H14.8534C15.4985 16.9649 16.1262 17.1495 16.6677 17.5003L18.0195 18.3772C18.2318 18.5156 18.4749 18.5844 18.718 18.5844C18.9282 18.5844 19.1385 18.5341 19.3313 18.4295C19.7436 18.2049 20 17.7731 20 17.3033V7.99052C20 6.43462 18.7354 5.17001 17.1795 5.17001H15.8974V3.88692C15.8974 2.33102 14.6328 1.06641 13.0769 1.06641H2.82051C1.26462 1.06641 0 2.33102 0 3.88692V13.1997C0 13.6695 0.25641 14.1013 0.668718 14.3259ZM15.8974 6.70847V10.0408C15.8974 11.5967 14.6328 12.8613 13.0769 12.8613H5.64105V14.1444C5.64105 14.851 6.21643 15.4264 6.9231 15.4264H14.8534C15.7959 15.4264 16.7118 15.6982 17.5036 16.21L18.4616 16.8305V7.99052C18.4616 7.28385 17.8862 6.70847 17.1795 6.70847H15.8974ZM1.53846 3.88692C1.53846 3.18025 2.11385 2.60487 2.82051 2.60487H13.0769C13.7836 2.60487 14.359 3.18025 14.359 3.88692V10.0408C14.359 10.7474 13.7836 11.3228 13.0769 11.3228H4.53949C3.99282 11.3228 3.46154 11.4797 3.00513 11.7772L1.53846 12.7279V3.88692Z"
        fill="#9C9C9C"
      />
    </g>
    <defs>
      <clipPath id="clip0_406_2682">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {};
</script>
